export default __webpack_public_path__ + "static/logo-textual-cropped-5d0a6eff15bb91859515b78828ac78bc.png";